import Vue from 'vue'

import RccSvgSprite from './rcc-svg-sprite.vue'
import RccIcon from './rcc-icon.vue'

Vue.component('rcc-svg-sprite', RccSvgSprite)
Vue.component('rcc-icon', RccIcon)
